import { BadgeColor, Badge as BadgeComponent } from '@givebutter/primitives/badge';
import { faTimes, faTrash } from '@fortawesome/pro-regular-svg-icons';
import { faCheck, faSpinnerThird } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ImportStatus } from 'types/domain';

const Badge = (props: { status: ImportStatus }) => {
    const { status } = props;

    let color: BadgeColor = 'neutral';
    let icon = null;
    let iconClasses = 'bg-gray-500';
    let label = '';

    switch (status) {
        case 'processing':
            label = 'Processing';
            color = 'warning';
            iconClasses = 'opacity-50 animate-spin';
            icon = faSpinnerThird;
            break;
        case 'succeeded':
            label = 'Completed';
            color = 'primary';
            iconClasses = '';
            icon = faCheck;
            break;
        case 'deleted':
            label = 'Deleted';
            color = 'error';
            iconClasses = '';
            icon = faTrash;
            break;
        case 'failed':
            label = 'Failed';
            color = 'error';
            iconClasses = '';
            icon = faTimes;
            break;
        case 'pending':
        case 'queued':
            label = 'In queue';
    }

    return (
        <BadgeComponent color={color}>
            {icon ? (
                <FontAwesomeIcon icon={icon} className={iconClasses} />
            ) : (
                <div className={`h-2 w-2 ${iconClasses} rounded-full`} />
            )}

            <span>{label}</span>
        </BadgeComponent>
    );
};

export { Badge };
